import { payPlanMobx, timePickMobx, buyTogetherMobx, eatTypeStatusMobx } from '@mobxStore'
import { cartMobx, discountMobx, productMobx, doComboMobx, doProductMobx, menuMobx, productSaleMobx, productCenter, restaurantConfig, storeMobx, restaurantCenter, doSwapBuyMobx } from 'restaurant'
import { modalLayer, alertLayer, showMsg, getHistoryNew, loadingLayer, getPlatform, miniAppRouteTo, toast } from '@utils'
import productStyleController from '@ctrls/productStyleController'
import CheckoutPayController from '@ctrls/checkoutPayController'
import RestoreOrderController from '@ctrls/restoreOrderController'
import TimePickController from '@ctrls/timePickController'
import ProductDetail from '@pages/detail/index'
import ModiferDetail from '@pages/detail/page/Modifier'
import CategoryModal from '@pages/menu/modal/CategoryModal'
import { SoldWarnModal, CanNotTogoModal, ExChangeModal } from '@pages/checkout/modal'
import { cloneDeep, flatten, map } from '@dt/fe-utils/dist/lodash'

class CashierController {
  /** 加入购物车(方法内逻辑) */
  static _addToCart (doProduct: any) {
    const _pk = cartMobx.addToCart(doProduct)
    // 主动换购
    if (doSwapBuyMobx.showAddCnt < 2) {
      setTimeout(() => {
        if (discountMobx.singleSwapBuyMap[_pk]?.canSwapBuy) {
          doSwapBuyMobx.pick({ parentCartItemPk: _pk })
          modalLayer(ExChangeModal, { }).then((product: any) => {
            this.addSwapBuyProduct(product, doSwapBuyMobx.doSwapBuy?.parentCartItem?.pk)
          }).catch(() => {
          })
        }
      }, 200)
    }
  }

  /** 选择加料 */
  static chooseModify (group: IDoModifierGroup, modify: IDoModifierGroupItem) {
    if ((group.cnt === group.selectMax && group.selectMax !== 1) && group.modifiers.find(v => v.no === modify.no && !v.cnt)) {
      showMsg(i18n.t('productdetail.moreRequest', { count: group.selectMax }))
      return
    }
    doProductMobx.selectModifier(group.no, modify.no)
  }

  /** 加入购物车 */
  static handleAddToCart (type: string, callback?: () => void) {
    let doProduct
    if (type === 'product') {
      doProduct = doProductMobx.doProduct
    } else if (['FixedCombo', 'OptionalCombo'].includes(type)) {
      doProduct = doComboMobx.doCombo
    }
    if (timePickMobx.canBookingTime && timePickMobx.productRuleMap?.[doProduct.no] && !doProduct.startTime && !Config.buyTogetherId) {
      if (!timePickMobx.productTimePickList?.length) {
        showMsg(i18n.t('newCart.noInReserveTime'))
        return
      }
      TimePickController.handleAppointment('product', {
        no: doProduct.no,
        startTime: doProduct.startTime,
        pickTimeRange: doProduct.pickTimeRange,
        callback: () => {
          const { startTime, pickTimeRange } = timePickMobx.productReserveInfo
          if (type === 'product') {
            doProductMobx.setStartTime(startTime, pickTimeRange)
          } else if (['FixedCombo', 'OptionalCombo'].includes(type)) {
            doComboMobx.setStartTime(startTime, pickTimeRange)
          }
          this._addToCart(doProduct)
          callback && callback()
        }
      })
    } else {
      if (Config.buyTogetherId) {
        buyTogetherMobx.onChangeProduct('add', doProduct)
      } else {
        this._addToCart(doProduct)
      }
      callback && callback()
    }
  }

  /** 加入换购 */
  static handleAddSwapBuyToCart (doProduct: IDoProduct | IDoCombo, parentCartItemPk: string, callback?: () => void) {
    if (timePickMobx.productRuleMap?.[doProduct.no] && !doProduct.startTime) {
      if (!timePickMobx.productTimePickList?.length) {
        showMsg(i18n.t('newCart.noInReserveTime'))
        return
      }
      TimePickController.handleAppointment('product', {
        no: doProduct.no,
        startTime: doProduct.startTime,
        pickTimeRange: doProduct.pickTimeRange,
        callback: () => {
          const { startTime, pickTimeRange } = timePickMobx.productReserveInfo
          const data = cloneDeep(doProduct)
          data.startTime = startTime
          data.pickTimeRange = pickTimeRange
          cartMobx.addSwapBuyToCart(data, parentCartItemPk)
          callback && callback()
        }
      })
    } else {
      cartMobx.addSwapBuyToCart(doProduct, parentCartItemPk)
      callback && callback()
    }
  }

  /** 餐品(包含套餐)加入购物车或者移除 thirdCouponCheckCB 三方券回调 */
  static handleProductToCart ({ type, product, isOrderSwapBuy, thirdCouponCheckCB, isAddProduct, directAddCnt }: { type: 'add' | 'minus'; product: IViewProduct; isOrderSwapBuy?: boolean; isAddProduct?: boolean; directAddCnt?: number; thirdCouponCheckCB?: (data?: any) => void }) {
    if (product.saleCnt === 0) return
    if (type === 'minus') {
      if (Config.buyTogetherId) {
        isAddProduct && doProductMobx.pick({ productNo: '' })
        isAddProduct ? doProductMobx.pick({ product, isOrderSwapBuy }) : doProductMobx.pick({ productNo: product.no, isOrderSwapBuy })
        doProductMobx.pickExt({ isAddProduct, isOrderSwapBuy })
        buyTogetherMobx.onChangeProduct(type, doProductMobx.doProduct)
      } else {
        cartMobx.reduce(product, isOrderSwapBuy)
      }
    } else {
      if (product.type === 'product') {
        isAddProduct && doProductMobx.pick({ productNo: '', initAdd: true })
        const cartItems = Config.buyTogetherId ? buyTogetherMobx.cartFormMenu : undefined
        isAddProduct ? doProductMobx.pick({ product, isOrderSwapBuy, initAdd: true, cartItems }) : doProductMobx.pick({ productNo: product.no, isOrderSwapBuy, initAdd: true, cartItems })
        doProductMobx.pickExt({ isAddProduct, isOrderSwapBuy, thirdCouponCheckCB })
        const canDirectAdd = product.scales?.length <= 1 && !product.modifierGroups?.length && !product.scales?.[0]?.modifierGroups?.length
        if (directAddCnt && canDirectAdd) {
          doProductMobx.setCnt(Math.max(directAddCnt, doProductMobx.doProduct.cnt))
        }
        if (!Config.buyTogetherId) {
          TimePickController.handleInitProduct(product.no)
        }
        if (product.scales?.length > 1 || product.modifierGroups?.length || product.scales?.[0]?.modifierGroups?.length) {
          this.showProductDetail(product)
        } else if (doProductMobx.doProductResult.isReady && doProductMobx.doProduct.scales.length <= 1) {
          // 餐品售罄
          if (doProductMobx.checkInvalid()) {
            showMsg(i18n.t('productdetail.saleOutTips2', { count: productSaleMobx.scaleNoToCntMap[`${product.no}_-1`]?.cnt }))
            return
          }
          // 加料项售罄
          if (doProductMobx.checkModifyInvalid()) {
            showMsg(i18n.t('productdetail.saleOutModifyTips'))
            return
          }
          if (!Config.buyTogetherId ? doProductMobx.checkMaxSalesCnt() : buyTogetherMobx.checkCartItemMaxSalesCnt()) {
            showMsg(i18n.t('productdetail.saleMaxCntModifyTips', { cnt: product.maxSalesCnt }))
            return
          }
          if (Config.buyTogetherId) {
            buyTogetherMobx.onChangeProduct(type, doProductMobx.doProduct)
          } else {
            this.handleAddToCart(doProductMobx.doProduct.type, () => {
              if (thirdCouponCheckCB) { // 三方券来的
                thirdCouponCheckCB({ status: 'success', type: 'addCart', from: 'auto' })
              }
            })
          }
        }
      } else if (['FixedCombo', 'OptionalCombo'].includes(product.type)) {
        doComboMobx.pick({ productNo: product.no, isOrderSwapBuy })
        doComboMobx.pickExt({ isAddProduct, isOrderSwapBuy, thirdCouponCheckCB })
        if (!Config.buyTogetherId) {
          TimePickController.handleInitProduct(product.no)
        }
        const hasModifiers = doComboMobx.doCombo.productGroups.some(pg => pg.productGroupDetails.some(p => p.modifierGroups.some(mg => mg.modifiers.length)))
        if (!doComboMobx.doComboResult.isReady || hasModifiers) {
          this.showProductDetail(product)
        } else if (doComboMobx.doComboResult.isReady) {
          if (doComboMobx.checkInvalid()) {
            showMsg(i18n.t('productdetail.saleOutTips2', { count: productSaleMobx.scaleNoToCntMap[`${product.no}_-1`]?.cnt }))
            return
          }
          if (Config.buyTogetherId) {
            buyTogetherMobx.onChangeProduct(type, doComboMobx.doCombo)
          } else {
            this.handleAddToCart(doComboMobx.doCombo.type, () => {
              if (thirdCouponCheckCB) { // 三方券来的
                thirdCouponCheckCB({ status: 'success', type: 'addCart', from: 'auto' })
              }
            })
          }
        }
      }
    }
  }

  /** 餐品（包含套餐）展示餐品详情 */
  static showProductDetail (product: IViewProduct | IViewCartItem) {
    CashierController.openProductDetail(product)
  }

  /** 餐品（包含套餐）展示餐品详情 */
  static openProductDetail (product: IViewProduct | IViewCartItem, extInfo?: { type: 'combo' | 'swapBuy' | 'fullNFree'; scaleNo?: string; targetNo?: string }) {
    const history = getHistoryNew()
    const isCombo = ['FixedCombo', 'OptionalCombo'].includes(product.type)
    const productNo = (product as IViewProduct).no || (product as IViewCartItem).productNo
    const hasPic = productMobx.noToViewProductMap[productNo]?.pic
    const params = { isModal: true, match: { params: {} } } as any
    if ((product as IViewCartItem).pk && !extInfo) {
      const productType = isCombo ? 'combo' : 'product'
      const pk = (product as IViewCartItem).pk
      if (hasPic || isCombo) {
        history.push(`/detail/${productType}/${pk}/${productNo}`)
      } else {
        params.match.params.productType = productType
        params.match.params.pk = pk
        modalLayer(ProductDetail, params, 'ProductDetail').then(() => {
        }, () => { })
      }
    } else {
      const productType = isCombo ? 'combo' : 'product'
      const { type, scaleNo, targetNo } = extInfo || {}
      if (hasPic || isCombo) {
        let path = `/${productType}/${productNo}`
        if (extInfo && type) path += `/${scaleNo}/${type}/${targetNo}`
        history.push(path)
      } else {
        params.match.params.productType = productType
        params.match.params.productNo = productNo
        if (extInfo) {
          params.match.params.scaleNo = scaleNo
          params.match.params.targetType = type
          params.match.params.targetNo = targetNo
        }
        modalLayer(ProductDetail, params, 'ProductDetail').then(() => {
        }, () => { })
      }
    }
  }

  /** 餐品（包含套餐）展示加料项详情 */
  static openModifierDetail (groupNo: string, { isModal, hideModifyDiscount = false }: { isModal?: boolean; hideModifyDiscount?: boolean }) {
    const history = getHistoryNew()
    if (isModal) {
      const params = { isModal: true, hideModifyDiscount, match: { params: {} } } as any
      params.match.params.modifierGroupNo = groupNo
      modalLayer(ModiferDetail, params, 'ModiferDetail').then(() => {
      }, () => { })
    } else {
      history.push(`/modifier/${groupNo}`)
    }
  }

  /** 展示餐品分类 */
  static showCategoryModal (isSearch: boolean = false) {
    modalLayer(CategoryModal, { isSearch }, 'categoryModal').then((categoryNoOrProduct: any) => {
      if (categoryNoOrProduct) {
        if (categoryNoOrProduct.type === 'product') {
          CashierController.showProductDetail(categoryNoOrProduct)
        } else {
          productStyleController.scollToCategory(categoryNoOrProduct)
        }
        menuMobx.setSearchKey(null)
      } else {
        const menuContent = document.querySelector('.menu-container') as any
        if (menuContent) {
          menuContent.scrollToTop()
        }
      }
    }, () => {})
  }

  /** 添加换购餐品动作 */
  static addSwapBuyProduct (product: IViewProduct, parentCartItemPk?: string) {
    if (product.saleCnt === 0) {
      return
    }
    const productNo = product.no
    const scaleNo = product.scales[0].no
    doProductMobx.pick({ productNo, product, scaleNo })
    doProductMobx.pickExt({
      swapBuy: {
        parentCartItemPk,
        maxCnt: parentCartItemPk ? discountMobx.singleSwapBuyMap[parentCartItemPk].activityProductsPsMap[`${productNo}_${scaleNo}`].cnt : 1,
      }
    })
    TimePickController.handleInitProduct(productNo)
    // 如果多规则只判断这个餐品必须是售罄的
    if ((doProductMobx.doProduct.scales.length > 1 && product.saleCnt === 0) || (doProductMobx.doProduct.scales.length === 1 && doProductMobx.checkInvalid())) {
      showMsg(i18n.t('productdetail.saleOutTips2'))
      return
    }
    // 加料项售罄
    if (doProductMobx.checkModifyInvalid()) {
      showMsg(i18n.t('productdetail.saleOutModifyTips'))
      return
    }
    const { doProduct } = doProductMobx
    const isAdd = doProductMobx.doProductResult.isReady && !(!restaurantConfig.defaultModifierSpecial && doProductMobx.doProduct.modifierGroups.some(mg => mg.modifiers.some(m => m.isDefault)))
    if (isAdd && doProduct.scales.length <= 1 && !doProduct.isOpenPrice && !doProduct.modifierGroups?.length) {
      this.handleAddSwapBuyToCart(doProduct, parentCartItemPk)
    } else {
      CashierController.openProductDetail(product, {
        type: 'swapBuy',
        scaleNo: product.scales[0].no,
        targetNo: parentCartItemPk,
      })
    }
  }

  /** 修改赠送餐品动作 */
  static editFullNFreeProduct (cartItem: IViewCartItem, parentCartItemPk?: string) {
    doProductMobx.pick({ cartItem })
    CashierController.openProductDetail(cartItem, {
      type: 'fullNFree',
      scaleNo: cartItem.scaleNo,
      targetNo: parentCartItemPk,
    })
  }

  /** 切换就餐方式 */
  static async switchEatType (eatType: TEatType) {
    if (eatType !== 'dinein') {
      const canotTogoCartItems = []
      cartMobx.viewCartItems.forEach(item => {
        !item.isCanTogo && canotTogoCartItems.push(item)
        item.swapBuyProducts?.forEach(swapItem => {
          !swapItem.isCanTogo && canotTogoCartItems.push(swapItem)
        })
        item.fullItemNFreeProducts?.forEach(fullNFreeItem => {
          !fullNFreeItem.isCanTogo && canotTogoCartItems.push(fullNFreeItem)
        })
      })
      if (canotTogoCartItems?.length && !Config.buyTogetherId) {
        modalLayer(CanNotTogoModal, { cartItems: canotTogoCartItems }).then(() => {
          flatten(map(canotTogoCartItems, 'pk')).forEach(pk => {
            const parentCartItem = cartMobx.viewCartItems.find(c => c.swapBuyProducts?.find(s => s.pk === pk))
            if (parentCartItem) {
              cartMobx.removeSwapBuyToCart(pk, parentCartItem.pk)
            } else {
              cartMobx.remove(pk)
            }
          })
          cartMobx.setEatType(eatType, { handler: true })
        }).catch(() => {
        })
      } else {
        cartMobx.setEatType(eatType, { handler: true })
      }
    } else {
      cartMobx.setEatType(eatType, { handler: true })
    }
  }

  /** 统一的下单错误处理 */
  static handleSaveError (err: any, scene: 'cart' | 'checkout') {
    const history = getHistoryNew()
    // 餐品售罄
    if (err && err.code === -602) {
      productSaleMobx.init().then(() => {
        /** 部分餐品售罄重算配送费 */
        cartMobx.setExpressList()
        discountMobx.calcCart()
      })
      const errData = err.data?.filter(item => item.productType !== 'modifier')
      if (!errData?.length) {
        const errModifierData = err.data?.filter(item => item.productType === 'modifier')
        alertLayer(errModifierData?.length ? i18n.t('cart.saleWarnModifier', { text: map(errModifierData, 'modifierName').join('、') }) : err.message)
        return Promise.reject()
      }
      modalLayer(SoldWarnModal, { hideCancel: !!Config.buyTogetherId, errData }).then(() => {}).catch(() => {
        // history.replace('/menu')
        history.go(0)
      })
      // 移除售罄餐品
      flatten(map(errData, 'pks')).forEach(pk => {
        const parentCartItem = cartMobx.viewCartItems.find(c => c.swapBuyProducts?.find(s => s.pk === pk))
        if (parentCartItem) {
          cartMobx.removeSwapBuyToCart(pk, parentCartItem.pk)
        } else {
          cartMobx.remove(pk)
        }
      })
      // 重新计算支付金额
      if (scene === 'checkout') {
        payPlanMobx.beginCalc()
      }
      return Promise.reject()
    }
    // 供应链校验货品库存不足
    if (err && err.code === 'supply-stock-insufficient') {
      modalLayer(SoldWarnModal, {
        type: 'supplyStock',
        errData: err.data
      })
        .then(() => {})
        .catch(() => {})
      return Promise.reject()
    }
    if (scene === 'cart') {
      alertLayer({
        message: err.message || i18n.t('checkout.orderHasFinishedAndContactWaiter'),
        button: i18n.t('cart.ikonw')
      }).then(() => {
        history.go(0)
        // history.replace('/result/' + orderMobx.order.ordersId)
      })
      loadingLayer.hide()
    } else if (scene === 'checkout') {
      alertLayer(err.message || i18n.t('cart.save_fail'))
    }
    return Promise.reject()
  }

  /** 发起支付错误处理 */
  static handleStartPayError (err: any) {
    if (err && err.code === -602) {
      productSaleMobx.init().then(() => discountMobx.calcCart())
    }
  }

  /** history */
  static history () {
    const history = getHistoryNew()
    return history
  }

  /** 跳转至订单结果页 */
  static toResult (ordersId) {
    const history = getHistoryNew()
    const { isWeixinMiniProgram } = getPlatform()
    if (isWeixinMiniProgram && !CheckoutPayController.getTempIsWxPay()) {
      let _url = `/pages/result/index?id=${ordersId}`
      if (Config.buyTogetherId) {
        _url += '&tt=buyTogether'
      }
      miniAppRouteTo({
        url: _url
      })
    } else {
      history.replace(`/result/${ordersId}`)
    }
  }

  /**
   * 初始进入页面，没有选过门店，选择逻辑
   * @param targetType {string}
   * @param type {string} 路由方法
   */
  static initInPageForNoStore (targetType: string = '', type: string = 'push') {
    const history = getHistoryNew()

    // 根据当前eatType判断选择第一家
    const filterStoreForEatType = () => {
      const eatType = Config.eatType
      const alist = storeMobx.viewStoreList
      const flist = alist.filter((store) => {
        if (eatType === 'delivery' && store.openSelfDelivery) {
          return true
        } else if (eatType === 'dinein') {
          return true
        } else if (eatType === 'pickup' || !eatType) {
          return true
        }
        return false
      })
      return flist?.length ? flist : alist
    }

    if (restaurantConfig.storeId) {
      // 如果当前门店发生了切换则切换菜单
      if (!productCenter.storeId || productCenter.storeId !== restaurantConfig.storeId) {
        restaurantCenter.init()
      }
      RestoreOrderController.restore()
    } else {
      const { lbs } = restaurantCenter.config

      // 如果进入时没有任何选中的门店，默认选中第一家
      if (storeMobx.viewStoreList.length) {
        if (storeMobx.viewStoreList.length === 1 || (lbs.lat && lbs.lng)) {
          if (Config.codeType === 'brand' && BASECONFIG.openEnterStore === 1) {
            history[type]('/store', null, { tt: targetType })
          } else {
            let list = filterStoreForEatType()
            if (Config.codeType === 'brand' && BASECONFIG.openEnterStore === 2 && list.length > 1) {
              const inSaleList = list
                .filter(item => item.status === 'inSale')
                .filter(i => i.distance ? i.distance < BASECONFIG.openEnterStoreDistance : false)
              if (!inSaleList.length) {
                history[type]('/store', null, { tt: targetType })
              }
            }
            const storeInfo = targetType === 'buyTogether' ? storeMobx.viewStoreList.find((item) => item.isOpenBuyTogether === 1) || storeMobx.viewStoreList[0] : list?.[0]
            storeMobx.initInfo({
              ...storeInfo,
              from: targetType
            })
            restaurantCenter.init()
            RestoreOrderController.restore()
          }
        } else {
          history[type]('/store', null, { tt: targetType })
        }
      }
    }
  }

  /** 校验是否可以加入购物车，临时关闭点单流程 */
  static checkCanCart () {
    const { canUseEatType } = eatTypeStatusMobx
    const { inSale, isMobileBookingOrder } = storeMobx.info
    if (restaurantConfig.codeType === 'brand') {
      const isCanBookingOrder = !!(timePickMobx.canPick && isMobileBookingOrder)
      // 未营业且可预约 或 营业且关闭所有就餐方式且可预约
      if (!inSale || !canUseEatType) {
        return isCanBookingOrder
      }
      return canUseEatType || isCanBookingOrder
    } else {
      return inSale && canUseEatType
    }
  }
}

export default CashierController
